import Dropdown from 'react-bootstrap/Dropdown';
import './MainBox.css';
import DatePicker from 'react-datepicker';
import PRHLoader from '../lib/PRHLoader';

export default function MetadataUS(props) {
    return (
        <>

            <div className={`metadata-container mb-2`}>
                <table className="metaData-table">
                    <tbody  >
                        <tr className="mb-1">
                            <td key="title-image" colSpan="3" rowSpan="2" style={{ width: "auto", minWidth: "80px", maxWidth: "150px", paddingLeft: "0" }}></td>


                                    <td rowSpan="2" colSpan="2">
                                        <div className="metaData-detail">&nbsp;</div>
                                    </td>
                            <td rowSpan="2" colSpan="5">
                                <div className="metaData-detail" style={{ color: "red", margin: "auto", fontSize: "20px" }}> {props?.ISBNId != null && props?.ISBNId != "" ? (props?.isMetaLoading ? "Loading Metadata..." : "No Metadata Available") : "No Title Selected"}</div>
                                    </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </>
    );
}